import {
  findStaticCompatibilityRedirect,
  normalizeRedirectTarget,
  stripTrailingSlash,
} from "./redirects.js";

const INTERNAL_HOST_PATTERN = /^https:\/\/(?:www\.)?elfletterbot\.com/i;
const CANONICAL_DOMAIN = "https://elfletterbot.com";

function splitPathSuffix(path) {
  const match = path.match(/^([^?#]*)(.*)$/);
  return {
    pathname: match?.[1] || path,
    suffix: match?.[2] || "",
  };
}

function applyInternalPathRedirects(path) {
  if (typeof path !== "string" || !path.startsWith("/")) {
    return path;
  }

  const { pathname, suffix } = splitPathSuffix(path);
  const redirect = findStaticCompatibilityRedirect(pathname);

  if (!redirect) {
    return path;
  }

  return `${stripTrailingSlash(redirect.target_path)}${suffix}`;
}

function encodeInternalPath(path) {
  try {
    return encodeURI(decodeURI(path));
  } catch {
    return encodeURI(path);
  }
}

export function normalizeInternalHref(href) {
  if (typeof href !== "string" || href.length === 0) {
    return href;
  }

  const isAbsoluteInternal = INTERNAL_HOST_PATTERN.test(href);
  const isRelativeInternal = href.startsWith("/");

  if (!isAbsoluteInternal && !isRelativeInternal) {
    return href;
  }

  const rawPath = isAbsoluteInternal ? href.replace(INTERNAL_HOST_PATTERN, "") || "/" : href;
  const rewrittenPath = rawPath.replace(/^\/article(?=\/|$)/, "/blog");
  const normalizedPath = encodeInternalPath(
    normalizeRedirectTarget(applyInternalPathRedirects(rewrittenPath)),
  );

  return isAbsoluteInternal ? `${CANONICAL_DOMAIN}${normalizedPath}` : normalizedPath;
}

export function normalizeInternalContentLinks(content) {
  if (typeof content !== "string" || content.length === 0) {
    return content;
  }

  return content.replace(
    /href=(['"])(https:\/\/(?:www\.)?elfletterbot\.com\/[^"']*|\/[^"']*)\1/gi,
    (match, quote, href) => `href=${quote}${normalizeInternalHref(href)}${quote}`,
  );
}
